module.exports = __webpack_public_path__ + "img/equatorial-guinea-logo-icon.2550d0dc.png";